module.exports = __webpack_public_path__ + "media/images/icons/material/timer-outline-0de3d68093498348584a772fab46f596.svg";